module.exports = __webpack_public_path__ + "static/media/DMC3-FM1.dbe5de8a.czml";